module.exports = __webpack_public_path__ + "static/media/Business Card-01.1be8d452.jpg";